import type { ReactNode } from 'react';
import { Fragment } from 'react';

/**
 * Parse a string with `**bold**` segments into a ReactNode array.
 * Pure utility — shared by FaqsAccordion and the SEO surfaces.
 */
export function parseInlineBold(text: string): ReactNode {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, idx) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      const inner = part.slice(2, -2);
      return (
        <strong key={`b-${String(idx)}-${inner.slice(0, 8)}`} className="font-medium">
          {inner}
        </strong>
      );
    }
    return <Fragment key={`t-${String(idx)}-${part.slice(0, 8)}`}>{part}</Fragment>;
  });
}
